var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHighAccuracy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_51",
    "data-name": "Layer 51",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c2c7cc;\n        opacity: .25;\n      }\n\n      .cls-2 {\n        fill: #4f7fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250,
    cy: 250,
    r: 162.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M388.6,226.98c-9.71-59.28-56.26-105.82-115.57-115.57v-48.9h-46.04v48.9c-59.27,9.76-105.82,56.31-115.57,115.57h-48.9v46.04h48.9c9.76,59.27,56.31,105.82,115.57,115.57v48.9h46.04v-48.9c59.31-9.76,105.86-56.29,115.57-115.57h48.9v-46.04h-48.9ZM343.86,260.52c-4.79,43.49-39.85,78.55-83.35,83.35-3.62.39-7.06.59-10.52.59s-6.95-.2-10.52-.59c-43.51-4.81-78.54-39.85-83.3-83.35v-.14c-.42-3.37-.63-6.87-.63-10.38s.21-7.01.62-10.38v-.14c4.78-43.51,39.81-78.54,83.44-83.32,3.4-.41,6.89-.62,10.39-.62s6.95.2,10.52.63c43.49,4.76,78.54,39.8,83.35,83.3.39,3.58.59,7.12.59,10.52s-.2,6.94-.59,10.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighAccuracy);
export default __webpack_public_path__ + "static/media/icon_high_accuracy.2040ddd1abb2bf62db7f73f26cd40f84.svg";
export { ForwardRef as ReactComponent };